import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { RdsToastService } from '@rds/angular-components';
import { catchError, mergeMap, tap } from 'rxjs';

import { AuthService } from '../../auth';
import { AuthApiService } from '../../auth/services/auth-api.service';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const authApiService = inject(AuthApiService);
  const toastService = inject(RdsToastService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        const refreshToken = authService.refreshToken;
        if (refreshToken) {
          return authApiService.refreshToken(refreshToken).pipe(
            tap(resp => authService.refresh(resp.idtoken, resp.access_token)),
            mergeMap(token =>
              next(
                req.clone({
                  setHeaders: {
                    Authorization: token.idtoken,
                  },
                })
              )
            ),
            catchError(error => {
              void authService.logout();
              handleLogoutError(error, toastService);
              throw error;
            })
          );
        } else {
          void authService.logout();
          handleLogoutError(err, toastService);
          throw err;
        }
      }
      if (err.status === 403) {
        void authService.logout();
        handleLogoutError(err, toastService);
        throw err;
      }
      throw err;
    })
  );
};

const handleLogoutError = (err: HttpErrorResponse, toast: RdsToastService) => {
  const message =
    err.error.authorizerContext?.description ??
    'Your session has expired. Please log in again.';
  toast.warning(message, 'Session expired', {
    disableTimeOut: true,
  });
};
